import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketService } from '@app/core/services/ticket.service';

@Component({
    selector: 'app-ticket-details',
    templateUrl: './ticket-details.component.html',
    styleUrls: ['./ticket-details.component.scss']
})
export class TicketDetailsComponent implements OnInit {
    ticketId: number;
    loading = false;
    tabs = [
        {
            link: 'details',
            label: 'service.tickets.details.tabs.details'
        },
        {
            link: 'tasks',
            label: 'service.tickets.details.tabs.tasks'
        }
    ]


    constructor(private route: ActivatedRoute, private ticketService: TicketService) {
    }

    ngOnInit() {
        this.loading = true;
        this.route.params.subscribe(
            (params) => {
                this.ticketId = +params['id'];
                this.getTicketHasTasks(this.ticketId);
            }
        );
    }

    getTicketHasTasks(ticketId: number) {
        this.ticketService.getTicketHasTasks(ticketId).subscribe(
            (data: boolean) => {
                this.tabs = this.computeTabs(data);
                this.loading = false;
            },
            (error) => {
                this.loading = false;
            }
        );
    }


    computeTabs(hasTasks: boolean) {
        return hasTasks ? [
            {
                link: 'details',
                label: 'service.tickets.details.tabs.details'
            },
            {
                link: 'tasks',
                label: 'service.tickets.details.tabs.tasks'
            }
        ] : [
            {
                link: 'details',
                label: 'service.tickets.details.tabs.details'
            }
        ];
    }

}
